import { ReactNode, useEffect } from "react";

interface CenteredPopupProps {
  isOpen: boolean;
  onClose: () => void;
  children: ReactNode;
  closeOnBackdrop?: boolean;
}

const CenteredPopup = ({
  isOpen,
  onClose,
  children,
  closeOnBackdrop = true,
}: CenteredPopupProps) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[300] flex items-center justify-center p-4">
      <div
        className="absolute inset-0 bg-black/50 transition-opacity duration-300"
        onClick={closeOnBackdrop ? onClose : undefined}
        aria-hidden
      />

      <div
        className="relative w-full max-w-[min(100vw-2rem,400px)] bg-white rounded-[36px] shadow-2xl z-10"
        role="dialog"
        aria-modal="true"
      >
        {children}
      </div>
    </div>
  );
};

export default CenteredPopup;
